export default __webpack_public_path__ + "static/media/icon_1.653e24a3.svg";